import GameObject from './GameObject';
import Vector2 from '../math/Vector2';
import Renderer from './rendering/Renderer';
import Moves from './Moves';
import RenderTarget from './rendering/RenderTarget';
import { InteractionType } from './rendering/InteractionHandler';
import Touch from './Touch';

/// #if DEVELOPMENT
import debugRender from './rendering/debugRender';
/// #endif DEVELOPMENT

export default abstract class Scene {
	gameObject: GameObject;
	moves: Moves;
	physics: any;

	_zIndex: number;
	speed: number;

	private _renderToTexture: boolean;
	private _renderTarget: RenderTarget | null;
	textureRatio: number;

	constructor () {
		this.gameObject = new GameObject({}, () => {});
		this.moves = new Moves();
		this.physics = null;

		this._zIndex = 0;
		this.speed = 1;

		this._renderToTexture = false;
		this._renderTarget = null;
		this.textureRatio = 1;
	}

	get zIndex () {
		return this._zIndex;
	}

	set zIndex (zIndex) {
		// TODO: trigger sort in parent
		this._zIndex = zIndex;
	}

	get renderTextureSet () {
		if (this._renderTarget === null) {
			throw new Error('No Render Target!');
		}

		return this._renderTarget.textureSet;
	}

	set renderToTexture (renderToTexture: boolean) {
		if (renderToTexture === this._renderToTexture) {
			return;
		}

		if (renderToTexture === true) {
			this._renderTarget = new RenderTarget(0, 0);
		} else {
			this._renderTarget = null;
		}
		this._renderToTexture = renderToTexture;
	}

	update (renderer: Renderer, dt: number) {
		dt *= this.speed;

		this.moves.tick(dt);

		if (this.physics !== null) {
			this.physics.update(dt);
		}

		this.gameObject.update(dt);

		// var aspectRatio = renderTarget.getAspectRatio();
		let frameBuffer = renderer.getCurrentFrameBuffer();
		if (this._renderToTexture === true) {
			if (this._renderTarget === null) {
				throw new Error('Render target is null!');
			}
			this._renderTarget.width = frameBuffer.width;
			this._renderTarget.height = frameBuffer.height;
			// Rendering shadow map
			frameBuffer = this._renderTarget.frameBuffer;
			renderer.useFrameBuffer(frameBuffer);
			this._renderTarget.clear(renderer);
		}

		this.render(renderer);

		if (this._renderToTexture === true) {
			renderer.popFrameBuffer();

			/// #if DEVELOPMENT
			// if (true && this._renderTarget !== null) {
			// 	debugRender(renderer, this._renderTarget.textureSet);
			// }
			/// #endif DEVELOPMENT
		}
	}

	abstract render (renderer: Renderer): void;
	// abstract handleEvent (eventType: string, position: Vector2) : void;

	abstract onInteraction (interactionType: InteractionType, event, touches: Array<Touch>): void;
}
